import { useParams } from 'react-router-dom';

import { useAppSelector } from 'app/hooks';
import { MembershipDeleteDialogContent } from 'common/components/deleteDialog/MembershipDeleteDialogContent';
import { selectPageInfo } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { deleteClaimUserMembership } from 'common/services/api/claimUserMembership/claimUserMembership.thunk';
import { DeleteDialogContentProps } from 'common/types/TypeDefs';

import { selectFilters } from './claimUserMembershipSlice';

type ClaimUserRow = { firstName: string; lastName: string; userId: string };

export function ClaimUserMembershipDeleteDialogContent({
    itemId,
    editingRow,
    paginationInfo,
    customDeleteTitle,
}: Readonly<DeleteDialogContentProps<ClaimUserRow>>) {
    const { firstName, lastName, userId } = editingRow ?? {};
    const { tenantId, claimId } = useParams();
    const pageInfo = useAppSelector(selectPageInfo);

    return (
        <MembershipDeleteDialogContent<ClaimUserRow, Parameters<typeof deleteClaimUserMembership>[0]>
            itemId={itemId}
            editingRow={editingRow}
            paginationInfo={paginationInfo}
            customDeleteTitle={customDeleteTitle}
            deleteThunk={deleteClaimUserMembership}
            entityName="User from Claim"
            successMessage="User has been removed from this Claim under this Tenant."
            selectFilters={selectFilters}
            infoItems={[
                { label: 'User', value: `${firstName} ${lastName}` },
                { label: 'Claim Name', value: pageInfo?.name },
                { label: 'Tenant Name', value: pageInfo?.tenantName },
            ]}
            buildDeleteParams={({ skip, take, search, sortModel, statusKeys }) => ({
                tenantId: tenantId ?? '',
                claimId: claimId ?? '',
                userId: userId ?? '',
                skip,
                take,
                search,
                sortModel,
                status: statusKeys,
            })}
        />
    );
}
